<template>
    <div class="ls-info-row">
        <div>
            <img :src="leftImage" class="ls-info-row--image" />
            <span class="ls-info-row--label">{{ label }}:</span> <span>{{ value }}</span>
        </div>
        <slot />
    </div>
</template>

<script>
import VueTypes from 'vue-types';

export default {
    name: 'LsInfoRow',
    props: {
        leftImage: VueTypes.string.isRequired,
        label: VueTypes.string.isRequired,
        value: VueTypes.string.isRequired,
    },
};
</script>

<style lang="scss" scoped>
.ls-info-row {
    color: $secondary;
    line-height: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;

    div {
        display: flex;
        align-items: center;
    }
}

.ls-info-row--image {
    margin-left: -5px;
    transform: translateY(-1px);
}

.ls-info-row--label {
    font-weight: $bold;
    margin: 0 2px;
}
</style>
